module.exports = __webpack_public_path__ + "static/media/domnic-brown.aca44ca2.png";